import React from "react";
import { statusMeta } from "@/lib/format";

export function StatusBadge({ status, testId }) {
  const m = statusMeta(status);
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
      style={{ backgroundColor: m.bg, color: m.text }}
    >
      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: m.dot }} />
      {m.label}
    </span>
  );
}

export function Pill({ children, tone = "slate", testId }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700",
    teal: "bg-teal-50 text-teal-700",
    red: "bg-red-50 text-red-700",
    amber: "bg-amber-50 text-amber-700",
    green: "bg-emerald-50 text-emerald-700",
  };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${tones[tone]}`}>
      {children}
    </span>
  );
}
